import React from "react";

const Loading: React.FC = () => {

  return (
    <>
      <div id="loading">
        <div className="disc">
          <img src="/assets/default/images/loader.gif" alt="Royal Botanic Gardens, Kew"/>
        </div>
      </div>
    </>
  );
};

export default Loading;